import styles from './index.module.css';

export default function Footer() {
  return (
    <>
      <div className={styles.footer}>
        <p style={{ marginBottom: 0 }}>
          Shadow Luna ©2022 Created by Christina
        </p>
      </div>
    </>
  );
}
